import { PhoneCall, CheckCircle2 } from "lucide-react";
import usePageMeta from "@/lib/usePageMeta";
import SectionHead from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import EmployerForm from "@/components/forms/EmployerForm";
import { CONTACT } from "@/lib/data";

const POINTS = [
  "Specialised IT and Non-IT recruitment across PAN India",
  "Relevant, qualified and carefully screened candidates",
  "Leadership, niche and volume hiring capability",
  "Structured process from briefing to joining follow-up",
];

export default function Employers() {
  usePageMeta(
    "Hire Talent in India | Share Your Hiring Requirement — Talentify",
    "Share your hiring requirement with Talentify. Our recruitment specialists help organisations across India identify, attract and hire the right talent faster."
  );
  return (
    <main>
      <section className="relative overflow-hidden pb-24 pt-40">
        <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(circle at 30% -10%, rgba(56,189,248,0.12), transparent 55%)" }} />
        <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-2">
          <div>
            <SectionHead overline="For Employers" title="Looking for the Right Talent?" testid="employers-page-heading" />
            <Reveal delay={0.1}>
              <p className="text-base leading-relaxed text-slate-400">
                Tell us what you're looking for. Our recruitment specialists will help you identify relevant talent and streamline your hiring process — whether it's one critical position or an entire team.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <ul className="mt-8 space-y-4">
                {POINTS.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-sm text-slate-300">
                    <CheckCircle2 size={17} className="mt-0.5 shrink-0 text-sky-400" />
                    {p}
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.26}>
              <a
                href={`tel:${CONTACT.phoneRaw}`}
                data-testid="employers-speak-expert-btn"
                className="mt-10 inline-flex items-center gap-2.5 rounded-full border border-white/15 px-7 py-3.5 text-sm font-semibold text-slate-200 transition-[border-color,background-color] duration-300 hover:border-sky-400/50 hover:bg-sky-400/5"
              >
                <PhoneCall size={16} className="text-sky-400" /> Speak With a Recruitment Expert — {CONTACT.phone}
              </a>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <div className="glass-card rounded-3xl p-7 sm:p-10">
              <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.25em] text-sky-400">Share Your Requirement</p>
              <EmployerForm compact />
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
